import { classed } from "@frend-digital/ui";
import type { ComponentProps } from "react";
import styles from "./Prose.module.css";

export type ProseProps = ComponentProps<"div">;

export const Prose = classed.div(styles.root, {
	variants: {
		small: {
			true: styles.small,
		},
	},
});
